export function resizeImage(
  dataURL: string,
  width: number,
  height: number
): Promise<string> {
  return new Promise((resolve) => {
    const image = new Image();
    image.src = dataURL;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      
      // Calculate scaling to maintain aspect ratio while filling the canvas
      const scaleX = width / image.width;
      const scaleY = height / image.height;
      const scale = Math.max(scaleX, scaleY);
      
      // Calculate the size of the scaled image
      const scaledWidth = image.width * scale;
      const scaledHeight = image.height * scale;
      
      // Calculate the position to center the image
      const x = (width - scaledWidth) / 2;
      const y = (height - scaledHeight) / 2;
      
      ctx!.drawImage(image, x, y, scaledWidth, scaledHeight);
      resolve(canvas.toDataURL());
    };
  });
}
